export default {
  hotsiteSlots: [],
}
